import { render } from "./OverviewGroup.vue?vue&type=template&id=9736b32a&scoped=true"
import script from "./OverviewGroup.vue?vue&type=script&lang=js"
export * from "./OverviewGroup.vue?vue&type=script&lang=js"

import "./OverviewGroup.vue?vue&type=style&index=0&id=9736b32a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9736b32a"]])

export default __exports__